// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2aYUE","error":"Textarea_error__3vWgG","readonly":"Textarea_readonly__3GqqI","disabled":"Textarea_disabled__2hLc-"};